import React, { useEffect, useRef } from 'react';

import { SketchPicker, ChromePicker } from 'react-color';

import { rgba2hex } from '../../utils/javascript';
import { EyeDropper } from './Eyedropper';
import { EyeDropperContainer } from './styles';

const ColorPicker = props => {
  const { onChange, color, onBlur, type, style, qlEditor } = props;
  const recentColor = useRef(color);
  const ref = useRef(null);

  const Picker = type === 'chromePicker' ? ChromePicker : SketchPicker;
  useEffect(() => {
    document.addEventListener('click', handleClicks);
    document.addEventListener('drag', handleClicks);
    return () => {
      document.removeEventListener('click', handleClicks);
      document.removeEventListener('drag', handleClicks);
    };
  }, []);

  const handleKeyUp = e => {
    if (qlEditor && e.keyCode === 13) {
      let container = document.getElementById('sketch-picker');
      container.click();
      onChange(recentColor.current);
    }
  };

  const handleClicks = e => {
    if (ref.current === null) return;
    const picker = document.getElementById('sketch-picker');
    let targetElement = e.target;
    do {
      if (targetElement === picker || ref.current.parentNode.parentNode.contains(targetElement)) {
        return;
      }
      targetElement = targetElement.parentNode;
    } while (targetElement);
    onBlur && onBlur();
  };

  const handleColors = (colors, event) => {
    const { target } = event;
    if (qlEditor && target && target.tagName === 'INPUT') {
      recentColor.current = colors;
      return;
    }
    const { r, g, b, a } = colors.rgb;
    let hex = '';
    if (colors.source === 'hex') {
      hex = colors.hex;
    } else {
      const rgba = `rgba(${r}, ${g}, ${b}, ${a})`;
      hex = rgba2hex(rgba);
    }
    colors = { ...colors, hex };
    onChange(colors);
  };

  const handlefocus = event => {
    event.stopPropagation();
    const { target } = event;
    if (target && target.tagName === 'INPUT') {
      target.focus();
    }
  };

  return (
    <div
      id="sketch-picker"
      style={style}
      onKeyUp={handleKeyUp}
      onClick={handlefocus}
      onDoubleClick={e => e.stopPropagation()}
      onKeyDown={e => e.stopPropagation()}
      ref={ref}
    >
      <Picker onChange={handleColors} color={color} />
      {type !== 'chromePicker' && (
        <EyeDropperContainer>
          <EyeDropper onPick={handleColors} />
        </EyeDropperContainer>
      )}
    </div>
  );
};
export default ColorPicker;
